import React from 'react'
import PropTypes from 'prop-types'

import { Box, Grid } from '@chatterbug/aaron'

const SingleStudyGoalSkeleton = ({
  title,
  numericProgressSection,
  progressBarSection,
}) => {
  return (
    <Grid
      gridGap={{ _: '0,5x', tablet: '1x' }}
      gridTemplateRows="auto 1fr"
      height="100%"
    >
      <Grid
        gridTemplateColumns={{ _: '1fr', tablet: 'repeat(2, 1fr)' }}
        alignItems="center"
        gridGap={{ mobile: '0,25x', tablet: '1x' }}
      >
        <Box as="p" variant="text.h5">
          {title}
        </Box>
        {numericProgressSection}
      </Grid>
      {progressBarSection}
    </Grid>
  )
}

SingleStudyGoalSkeleton.propTypes = {
  title: PropTypes.string,
  numericProgressSection: PropTypes.any,
  progressBarSection: PropTypes.any,
}
export default SingleStudyGoalSkeleton
